import axios from "axios";

//TODO move urls to .env
//const url = 'http://localhost:8080';
const url = process.env.API_URL;

const api = axios.create({
    baseURL: url,
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
});

export default api;
